var React = require('react');

function Bolt (props) {
    return React.createElement("svg",props,[React.createElement("g",{"transform":"translate(2.999)","key":0},React.createElement("path",{"fill":"#01104b","d":"M80.983,7.585H72.759L77.131,0H67.244L62.878,12.478H69.9L66.786,24Z","transform":"translate(-62.878)"})),React.createElement("rect",{"fill":"none","width":"24","height":"24","key":1})]);
}

Bolt.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Bolt;

Bolt.default = Bolt;
